import type { StoredAuthTokens } from './tokenStore';

export type HostMessage =
  | { source: 'mcp-host'; type: 'setTokens'; tokens: StoredAuthTokens }
  | { source: 'mcp-host'; type: 'clearTokens' }
  | { source: 'mcp-host'; type: 'requestRefresh' }
  | { source: 'mcp-host'; type: 'logout' };

export type FrameMessage =
  | { source: 'auth-frame'; type: 'tokens'; tokens: StoredAuthTokens | null }
  | { source: 'auth-frame'; type: 'logout' }
  | { source: 'auth-frame'; type: 'apiKeyCreated'; apiKey: string };

function postToHost(msg: FrameMessage): void {
  // Send to parent (webview) if embedded, otherwise noop
  if (typeof window === 'undefined') return;
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(msg, '*');
  }
  if (window.opener && window.opener !== window) {
    window.opener.postMessage(msg, '*');
  }
}

export function notifyTokens(tokens: StoredAuthTokens | null): void {
  postToHost({ source: 'auth-frame', type: 'tokens', tokens });
}

export function notifyLogout(): void {
  postToHost({ source: 'auth-frame', type: 'logout' });
}

export function notifyApiKeyCreated(apiKey: string): void {
  postToHost({ source: 'auth-frame', type: 'apiKeyCreated', apiKey });
}

export function subscribeHostMessages(
  handler: (msg: HostMessage) => void,
): () => void {
  const listener = (event: MessageEvent) => {
    const data = event.data;
    if (!data || data.source !== 'mcp-host') return;
    handler(data as HostMessage);
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
